﻿export class Heartbeat {
    public static start(videoSessionId: number): void {
        setInterval(() => Heartbeat.loop(videoSessionId), 3000);
    }

    private static loop(videoSesionId: number): void {
        console.log('heartbeat', videoSesionId);
        fetch('/api/meetings/heartbeat/' + videoSesionId, {
            method: 'POST',
        }).catch(function (ex) {
            console.log('could not send heartbeat', ex);
        });
    }
}
